import { useState, ReactNode } from 'react';
import { Menu, X } from 'lucide-react';
import { SettingsNav } from './SettingsNav';

interface SettingsLayoutProps {
  children: ReactNode;
  activeSection: string;
  onSectionChange: (section: string) => void;
}

export function SettingsLayout({ children, activeSection, onSectionChange }: SettingsLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-full overflow-hidden">
      <button
        onClick={() => setSidebarOpen(!sidebarOpen)}
        className="fixed top-20 left-4 z-50 p-2 bg-white border border-gray-200 rounded-lg shadow-sm lg:hidden hover:bg-gray-50 transition-colors"
      >
        {sidebarOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
      </button>

      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black/20 z-30 lg:hidden"
        />
      )}

      <aside
        className={`
          fixed lg:sticky top-0 left-0 h-full w-[280px] bg-gradient-to-br from-white to-[#1875FF]/5 border-r border-[#1875FF]/20
          transition-transform duration-300 z-40 flex-shrink-0 shadow-lg
          ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        <div className="h-full overflow-y-auto settings-scrollbar p-4">
          <SettingsNav activeSection={activeSection} onSectionChange={onSectionChange} />
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto bg-gradient-to-br from-white to-blue-50/30">
        <div className="p-6 lg:p-8">
          {children}
        </div>
      </main>
    </div>
  );
}
